import { getCloudinaryUrl } from "@/lib/cloudinary";
// Types d'événements du soir
export type EveningEvent = {
  id: number;
  title: string;
  description: string;
  price?: number;
  startDateTime: string; // Format YYYY-MM-DD HH:mm
  endDateTime: string; // Format YYYY-MM-DD HH:mm
  location: string;
  salon: string;
  whatsappLink?: string;
  image: string;
  isComplete?: boolean;
  isComingSoon?: boolean;
};

// Liste des événements du soir
export const eveningEvents: EveningEvent[] = [
  {
    id: 2,
    title: "Soirée massage, bien-être et Voyage Sonore",
    description:
      "Relaxation absolue avec bols tibétains et dégustation gourmande.",
    price: 95,
    startDateTime: "2025-06-24 20:00",
    endDateTime: "2025-06-24 22:00",
    location: "Villejuif",
    salon: "Villejuif",
    image: getCloudinaryUrl("soiree-massage-bien-etre-voyage-sonnore"),
    whatsappLink: "https://chat.whatsapp.com/CaK7RTZaVqZ2D2I6a6lgks",
  },
  {
    id: 3,
    title: "Duo Voyage Sonore et Tarot Divinatoire",
    description:
      "Séance de voyance, massage détente et ambiance immersive sonore. Assiette gourmande incluse.",
    price: 125,
    startDateTime: "2025-06-30 20:00",
    endDateTime: "2025-06-30 22:00",
    location: "Villejuif",
    salon: "Villejuif",
    image: getCloudinaryUrl("soiree-duo-tarot-divinatoire-voyage-sonore-1"),
    whatsappLink: "https://chat.whatsapp.com/IL87Gdd4CVvIpwCDrydqEf",
  },
  {
    id: 4,
    title: "Duo : Voyage Sonore & Tarot Divinatoire",
    description:
      "Séance voyage, relaxation avec lectures personnalisées. Assiette gourmande incluse.",
    price: 125,
    startDateTime: "2025-06-19 20:00",
    endDateTime: "2025-06-19 22:00",
    location: "Ville d'Avray",
    salon: "Ville d'Avray",
    image: getCloudinaryUrl("soiree-duo-tarot-divinatoire-voyage-sonore-2"),
    isComplete: true,
  },
  {
    id: 5,
    title: "Soirée Massage, Détente & Voyage Sonore",
    description: "Massage détente et ambiance immersive avec bols tibétains.",
    price: 95,
    startDateTime: "2025-06-26 20:00",
    endDateTime: "2025-06-26 22:00",
    location: "Ville d'Avray",
    salon: "Ville d'Avray",
    image: getCloudinaryUrl("soiree-massage-detente-voyage-sonore"),
    whatsappLink: "https://chat.whatsapp.com/DGrWvcD3SQeIhcxnftSVm8",
  },
  {
    id: 6,
    title: "Soirée Beauté & Tarot Divinatoire",
    description:
      "Massage détente, voyage sonore immersif. Assiette gourmande incluse.",
    price: 95,
    startDateTime: "2025-07-01 20:00",
    endDateTime: "2025-07-01 22:00",
    location: "Ville d'Avray",
    salon: "Ville d'Avray",
    image: getCloudinaryUrl("soiree-beaute-tarot-divinatoire-2"),
    isComplete: true,
  },

  // {
  //   id: 7,
  //   title: "Voyage au tambour et voyance",
  //   description:
  //     "Une expérience unique combinant un voyage sonore au tambour chamanique et une séance de voyance personnalisée. Assiette gourmande incluse.",
  //   price: 95,
  //   startDateTime: "2025-07-15 20:00",
  //   endDateTime: "2025-07-15 22:00",
  //   location: "Villejuif",
  //   salon: "Villejuif",
  //   image: getCloudinaryUrl("soiree-voyance"),
  //   isComingSoon: true,
  // },
  {
    id: 8,
    title: "Voyage au tambour et voyance",
    description:
      "Une expérience unique combinant un voyage sonore au tambour chamanique et une séance de voyance personnalisée. Assiette gourmande incluse.",
    price: 95,
    startDateTime: "2025-07-21 20:00",
    endDateTime: "2025-07-21 22:00",
    location: "Ville d'Avray",
    salon: "Ville d'Avray",
    image: getCloudinaryUrl("soiree-voyage-tambour"),
    whatsappLink: "https://chat.whatsapp.com/LwwN9FLxdpH5K1mo4QWSZw",
  },
  {
    id: 9,
    title: "Voyage sonore",
    description:
      "Une immersion sonore profonde avec les bols tibétains pour une relaxation totale. Assiette gourmande incluse.",
    price: 95,
    startDateTime: "2025-07-22 20:00",
    endDateTime: "2025-07-22 22:00",
    location: "Villejuif",
    salon: "Villejuif",
    image: getCloudinaryUrl("soiree-voyage-tambour2"),
    whatsappLink: "https://chat.whatsapp.com/HDuYfvmukzb6029zcY15Dx",
  },
  // {
  //   id: 10,
  //   title: "Voyage au tambour et voyance",
  //   description:
  //     "Une expérience unique combinant un voyage sonore au tambour chamanique et une séance de voyance personnalisée. Assiette gourmande incluse.",
  //   price: 95,
  //   startDateTime: "2025-07-29 20:00",
  //   endDateTime: "2025-07-29 22:00",
  //   location: "Ville d'Avray",
  //   salon: "Ville d'Avray",
  //   image: getCloudinaryUrl("soiree-voyance2"),
  //   isComingSoon: true,
  // },
  {
    id: 11,
    title: "Cercle de femme et tarot divinatoire",
    description:
      "Une immersion sonore profonde avec les bols tibétains pour une relaxation totale. Assiette gourmande incluse.",
    startDateTime: "2025-11-04 20:00",
    endDateTime: "2025-11-04 22:00",
    location: "Au Grey des couleurs",
    salon: "Au Grey des couleurs",
    image: getCloudinaryUrl("cercle-femmes-tarot-divinatoire"),
    isComplete: true,
  },
  {
    id: 12,
    title: "Atelier de 10h à 12h \"Sommeil réparateur : rituels et astuces\"",
    description:
      "Retrouvez un sommeil paisible et profond grâce à cet atelier dédié à l'art du repos\nUn moment pour comprendre, expérimenter et créer vos propres rituels afin d'améliorer la qualité de votre sommeil — naturellement et durablement.\n\nAu programme :\n😴 Comprendre les causes des troubles du sommeil\n🕯️ Découvrir des rituels du soir apaisants\n🌸 Apprendre des techniques de relaxation et de respiration\n💧 Explorer des astuces simples pour favoriser l'endormissement",
    startDateTime: "2025-11-12 10:00",
    endDateTime: "2025-11-12 12:00",
    location: "Au Grey des couleurs",
    salon: "Au Grey des couleurs",
    image: getCloudinaryUrl("sommeil-reparateur"),
    isComplete: true,
    whatsappLink: "https://chat.whatsapp.com/JMVmmHkmxTFAzu6LVk6r5o"
  },
  {
    id: 13,
    title: "Atelier de 10h à 12h \"Maman et future maman : je prends soin de moi\"",
    description:
      "Prenez une pause rien que pour vous 💕\nCet atelier est une bulle de douceur dédiée aux mamans et futures mamans, pour se reconnecter à soi, se détendre et nourrir son bien-être intérieur.\n\nAu programme :\n✨ Un moment de relaxation et de recentrage\n💆‍♀️ Des conseils bien-être et auto-soin\n🤰 Des échanges bienveillants entre femmes",
    startDateTime: "2025-11-24 10:00",
    endDateTime: "2025-11-24 12:00",
    location: "Au Grey des couleurs",
    salon: "Au Grey des couleurs",
    image: getCloudinaryUrl("maman-et-future-maman"),
    isComplete: true,
    whatsappLink: "https://chat.whatsapp.com/FX20bWUvJ3k6hNXnsChq4r"
  },
  {
    id: 14,
    title: "Atelier de 10h à 12h \"Trouver un sommeil profond et réparateur\"",
    description:
      "Retrouvez un sommeil paisible et profond grâce à cet atelier dédié à l'art du repos.\nUn temps pour se déposer, comprendre son rythme et créer des rituels du soir qui apaisent durablement.\n\nAu programme :\n🌙 Comprendre les mécanismes du sommeil\n🫖 Installer des rituels doux et apaisants\n🌿 Explorer la respiration et la relaxation\n☁️ Découvrir des astuces simples pour s'endormir sereinement",
    startDateTime: "2026-01-12 10:00",
    endDateTime: "2026-01-12 12:00",
    location: "Au Grey des couleurs",
    salon: "Au Grey des couleurs",
    image: getCloudinaryUrl("sommeil_reparateur_v2"),
    whatsappLink: "https://chat.whatsapp.com/JMVmmHkmxTFAzu6LVk6r5o"
  },
  {
    id: 15,
    title: "Atelier de 10h à 12h \"Être maman, c'est aussi se préserver\"",
    description:
      "Offrez-vous un moment rien que pour vous 🌷\nUne parenthèse de douceur pour se reconnecter à son corps, son souffle et ses émotions — dans un espace bienveillant entre mamans et futures mamans.\n\nAu programme :\n🌼 Un temps de détente et d'ancrage\n🪞 Petits gestes d'auto-soin & bien-être\n🌱 Partages sincères entre femmes",
    startDateTime: "2026-02-09 10:00",
    endDateTime: "2026-02-09 12:00",
    location: "Au Grey des couleurs",
    salon: "Au Grey des couleurs",
    image: getCloudinaryUrl("maman_et_future_maman_v2"),
    whatsappLink: "https://chat.whatsapp.com/FX20bWUvJ3k6hNXnsChq4r"
  }
];
